import { render } from "./counter.vue?vue&type=template&id=070ac0aa&scoped=true"
import script from "./counter.vue?vue&type=script&lang=js"
export * from "./counter.vue?vue&type=script&lang=js"

import "./counter.vue?vue&type=style&index=0&id=070ac0aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070ac0aa"]])

export default __exports__